import { render, staticRenderFns } from "./taskOver.vue?vue&type=template&id=4695f4ee&scoped=true"
import script from "./taskOver.vue?vue&type=script&lang=js"
export * from "./taskOver.vue?vue&type=script&lang=js"
import style0 from "./taskOver.vue?vue&type=style&index=0&id=4695f4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4695f4ee",
  null
  
)

export default component.exports